import { Popover } from '@mui/material';
import React, { FC, useState } from 'react';
import classes from './ColorPicker.module.css';
import { ColorResult, SketchPicker } from 'react-color';
import { toast } from 'react-toastify';

type ColorPickerProps = {
  color: string;
  onChange: (color: string) => void;
};

const ColorPicker: FC<ColorPickerProps> = ({ color, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleChangeComplete = (color: ColorResult) => {
    if (color.hex === '#ffffff') {
      toast.error("You can't choose this color", {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      });

      return;
    }
    onChange(color.hex);
  };

  return (
    <>
      <button
        aria-describedby={id}
        onClick={handleClick}
        className={classes.button}
        style={{
          backgroundColor: color,
        }}
      ></button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <SketchPicker
          color={color}
          onChangeComplete={handleChangeComplete}
          presetColors={[
            '#D0021B',
            '#F5A623',
            '#F8E71C',
            '#8B572A',
            '#7ED321',
            '#417505',
            '#BD10E0',
            '#9013FE',
            '#4A90E2',
            '#50E3C2',
            '#B8E986',
            '#000000',
            '#4A4A4A',
            '#9B9B9B',
          ]}
        />
      </Popover>
    </>
  );
};

export default ColorPicker;
